import { AuthToken } from '@cobliteam/api-lib/src/account/session/AuthToken';
import useUser from '@cobliteam/hooks/src/useEntity/useUser';
import useSessionStore from '@cobliteam/hooks/src/useSession/store/useSessionStore';
import useSessionQuery from '@cobliteam/hooks/src/useSession/useSessionQuery';
import useSyncUserDataSideEffects from '@cobliteam/hooks/src/useSession/useSyncUserDataSideEffects';
import type React from 'react';
import { Redirect } from 'react-router-dom';
import LoadingPage from '../pages/LoadingPage';

interface PrivateRouterProviderProps {
  children: React.ReactNode;
}

const PrivateRouterProvider = ({ children }: PrivateRouterProviderProps) => {
  const session = useSessionStore((s) => s.session);
  const authToken = localStorage.getItem(AuthToken.ACCESS_TOKEN);

  // Revalida sessão em background contra /account/session. O `setSession` acontece dentro da
  // queryFn — quando a resposta chega, o `useAuthStore` atualiza atomicamente e o `useUserData`
  // abaixo já enxerga a sessão fresca sem esperar uma render cycle extra.
  useSessionQuery();

  const { useGetUserData } = useUser();
  const { data: userData } = useGetUserData();

  // Sincroniza o `userData` fresco nos stores periféricos. Único ponto de mount para evitar
  // duplicação vs. consumidores múltiplos.
  useSyncUserDataSideEffects(userData, session?.user.id);

  if (!authToken) return <Redirect to='/login' />;

  // Otimista: se `useAuthStore` persistiu a sessão do último acesso ou a revalidação em background
  // já retornou, renderiza imediatamente.
  if (session) return <>{children}</>;

  return <LoadingPage showLogo message='Carregando suas preferências e dados...' />;
};

export default PrivateRouterProvider;
